import { AlertCircle, Check, Loader2 } from 'lucide-react';
import type { AutosaveStatus } from '@/hooks/useAutosave';

export function AutosaveIndicator({ status }: { status: AutosaveStatus }) {
  if (status === 'idle') return null;

  return (
    <div className="flex items-center gap-[6px] text-[13px]">
      {status === 'saving' && (
        <>
          <Loader2 size={14} className="animate-spin text-[#8d8c8f]" />
          <span className="text-[#8d8c8f]">Saving...</span>
        </>
      )}
      {status === 'saved' && (
        <>
          <Check size={14} className="text-[#055135]" />
          <span className="text-[#055135]">Saved</span>
        </>
      )}
      {status === 'error' && (
        <>
          <AlertCircle size={14} className="text-[#d4183d]" />
          <span className="text-[#d4183d]">Save failed</span>
        </>
      )}
    </div>
  );
}
